import React, { useEffect, useState } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, List, ListItem, ListItemText, IconButton, Box } from '@mui/material'
import ArrowUpward from '@mui/icons-material/ArrowUpward'
import ArrowDownward from '@mui/icons-material/ArrowDownward'
import api from '../services/api'
import * as qs from 'qs'
import { useEvent } from '../contexts/event.context'

export default function OrdenateEventsModal({ open, onClose }) {
    const { reorderEvents, getEvents } = useEvent()
    const [items, setItems] = useState([])
    const [saving, setSaving] = useState(false)

    useEffect(() => {
        async function load() {
            try {
                const query = qs.stringify({
                    filters: {
                        deleted: { $eq: false },
                        isActive: { $eq: true },
                        isVisible: { $eq: true }
                    },
                    fields: ['name', 'position', 'isActive', 'isVisible', 'deleted'],
                    pagination: { page: 1, pageSize: 100 },
                    sort: ['position:asc'],
                    encodeValuesOnly: true
                })
                const res = await api.get(`/events?${query}`)
                if (res.status === 200 && res.data && res.data.data) {
                    const data = res.data.data
                        .map((e, idx) => ({ id: e.id, name: e.attributes?.name || `Evento ${e.id}`, position: e.attributes?.position ?? idx + 1 }))
                    setItems(data)
                }
            } catch (error) {
                console.error('load ordenate events', error)
            }
        }
        if (open) load()
    }, [open])

    function moveUp(index) {
        if (index === 0) return
        const copy = [...items]
        const tmp = copy[index - 1]
        copy[index - 1] = copy[index]
        copy[index] = tmp
        setItems(copy)
    }
    function moveDown(index) {
        if (index === items.length - 1) return
        const copy = [...items]
        const tmp = copy[index + 1]
        copy[index + 1] = copy[index]
        copy[index] = tmp
        setItems(copy)
    }

    async function handleSave() {
        setSaving(true)
        try {
            const payload = items.map((it, idx) => ({ id: it.id, position: idx + 1 }))
            await reorderEvents(payload)
            await getEvents(1, 10, true)
            setSaving(false)
            onClose(true)
        } catch (error) {
            console.error('save reorder', error)
            setSaving(false)
            onClose(false)
        }
    }

    return (
        <Dialog open={open} onClose={() => onClose(false)} fullWidth maxWidth="sm">
            <DialogTitle>Ordenar Eventos</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 1 }}>
                    <List>
                        {items.map((item, idx) => (
                            <ListItem key={item.id} secondaryAction={
                                <>
                                    <IconButton edge="end" aria-label="up" onClick={() => moveUp(idx)}>
                                        <ArrowUpward />
                                    </IconButton>
                                    <IconButton edge="end" aria-label="down" onClick={() => moveDown(idx)}>
                                        <ArrowDownward />
                                    </IconButton>
                                </>
                            }>
                                <ListItemText primary={item.name} secondary={`Posição: ${idx + 1}`} />
                            </ListItem>
                        ))}
                    </List>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(false)} disabled={saving}>Cancelar</Button>
                <Button onClick={handleSave} disabled={saving} variant="contained">Salvar</Button>
            </DialogActions>
        </Dialog>
    )
}
